import { IAppState } from 'src/store/types';

export const getFilterParamData = (state: IAppState) => state.filterParams;
export const getFilterHasNotResults = (state: IAppState) => state.filterParams.filterHasNoResults;
export const getFilterScrollPosition = (state: IAppState) => state.filterParams.scrollPosition;
export const getFilterLeavedSlide = (state: IAppState) => state.filterParams.leavedSlide;
export const getFilterParamDataCountDesktopResult = (state: IAppState) => state.filterParams.countShowDesktopResult;
export const getFilterParamDataCountMobileResult = (state: IAppState) => state.filterParams.countShowMobileResult;
